module.exports = __webpack_public_path__ + "static/media/general.af8af6c5.svg";